<template lang="pug">
  .modal__row
    .modal__col(v-if="characteristics[characteristicYear]" )
      e-form-subtitle(
        text="Доля отбираемых ресурсов"
        v-if="fields.tkoActionsArray.indexOf(TransportationId) > -1 || fields.tkoActionsArray.indexOf(ProcessingId) > -1 || fields.tkoActionsArray.indexOf(ProcessingId) > -1"
      )
      e-form-group(
        name="part_secondary"
        label="Доля отбора вторичных материальных ресурсов"
        :model="characteristics[characteristicYear]"
        validationRule="number"
        tabView="tab6"
        v-if="hasLeftoverCapacity"
        :validationAdditionalRules="{minValue: 0, maxValue: 100}"
      )
      e-form-group(
        name="part_fuel_production"
        :label="partFuelProductionText"
        :model="characteristics[characteristicYear]"
        validationRule="double"
        tabView="tab6"
        v-if="hasLeftoverCapacity"
        :validationAdditionalRules="{minValue: 0, maxValue: 100}"
      )
      e-form-subtitle(text="План модернизации")
      e-form-group(
        name="tko_object_id"
        inputType="select"
        label="Состояние объекта"
        :model="characteristics[characteristicYear]"
        :options="tkoObjectStateOptions"
        tabView="tab6"
      )
      e-form-group(
        name="area_garbage"
        label="Площадь участка под размещение отходов, га"
        :model="characteristics[characteristicYear]"
        validationRule="double"
        tabView="tab6"
      )
      e-form-group(
        name="power"
        :label="objectPowerText"
        :model="characteristics[characteristicYear]"
        validationRule="double"
        tabView="tab6"
      )
      e-form-group(
        v-if='hasObjectFreePower'
        name="free_power"
        :label="objectFreePowerText"
        :model="characteristics[characteristicYear]"
        validationRule="double"
        tabView="tab6"
      )
      e-form-group(
        v-if='hasObjectFreePower && hasObjectFreePowerCub'
        name="free_power_cub"
        :label="objectFreePowerCubText"
        :model="characteristics[characteristicYear]"
        validationRule="double"
        tabView="tab6"
      )
      e-form-group(
        name="coefficient_compaction"
        label="Коэффициент уплотнения"
        :model="fields"
        validationRule="double"
        tabView="tab6"
        v-if="fields.tkoActionsArray.indexOf(TransportationId) > -1"
      )
    .modal__col
      div(v-if='hasForecast')
        e-form-subtitle(text="Прогноз вместимости и срока эксплуатации")
        e-form-group(
          v-if="hasLeftoverCapacity"
          name="leftover_capacity"
          label="Вместимость (остаточная), тонн"
          :model="characteristics[characteristicYear]"
          validationRule="double"
          tabView="tab6"
          :disabled='true'
        )
        e-form-group(
          name="operation_period"
          label="Остаточный срок эксплуатации объекта, лет"
          :model="characteristics[characteristicYear]"
          validationRule="double"
          tabView="tab6"
          :disabled="true"
        )
    .modal__col
      e-form-subtitle(text="Выбрать год выдачи данных")
      select.select(v-model='characteristicYear' @change="$emit('setCharacteristicFields')")
        option(v-for='(item, index) in characteristicYears' :key="'characteristicYear-' + index" :value='item') {{item}}
</template>

<script>
import hasMixin from '@/mixins/has-mixin'
import textMixin from '@/mixins/text-mixin'
import year from '@/utils/year'

import { TransportationId, ProcessingId } from '@/config/config'

export default {
  name: 'object-characteristic',
  mixins: [hasMixin, textMixin],
  props: {
    fields: {
      type: Object,
      required: true,
    },
    characteristics: {
      type: Object,
      required: true,
    },
    characteristicYears: {
      type: Array,
      required: true,
    },
    tkoObjectStateOptions: {
      type: Array,
      required: true,
    },
    hasForecast: {
      required: true,
    },
    hasLeftoverCapacity: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      characteristicYear: year.getCurrentYear(),
    }
  },
  computed: {
    TransportationId() {
      return TransportationId
    },
    ProcessingId() {
      return ProcessingId
    },
  },
}
</script>
